var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: "",
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData(true)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "message-list" },
            _vm._l(_vm.currentMessages, function(msg, index) {
              return _c("div", { key: index, class: ["msg-item", msg.role] }, [
                msg.role === "user"
                  ? _c("div", { staticClass: "user-msg" }, [
                      _vm._v(_vm._s(msg.content))
                    ])
                  : _vm._e(),
                msg.role === "ai"
                  ? _c("div", { staticClass: "ai-msg-box" }, [
                      msg.reasoning
                        ? _c("div", { staticClass: "reasoning-text" }, [
                            _vm._v(_vm._s(msg.reasoning))
                          ])
                        : _vm._e(),
                      msg.done
                        ? _c("div", { staticClass: "done-text" }, [
                            _vm._v(_vm._s(msg.done))
                          ])
                        : _vm._e(),
                      msg.error
                        ? _c("div", { staticClass: "done-text" }, [
                            _vm._v(_vm._s(msg.error))
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }